import { useCallback, useEffect, useState } from 'react'

import { Button } from '@/components/ui/button'
import { RangeSlider } from '@/components/ui/slider'

type SpeedControlProps = {
  presetSpeeds: number[]
  min: number
  max: number
  step: number
  playbackSpeed: number
  onChangeSpeed: (speed: number) => void
}

export const SpeedControl = ({ presetSpeeds, min, max, step, playbackSpeed, onChangeSpeed }: SpeedControlProps) => {
  const [displaySpeed, setDisplaySpeed] = useState(playbackSpeed)

  // playbackSpeedが外部から変更されたらdisplaySpeedも同期
  useEffect(() => {
    setDisplaySpeed(playbackSpeed)
  }, [playbackSpeed])

  // プリセット速度を設定
  const handlePresetSpeed = useCallback(
    (speed: number) => {
      setDisplaySpeed(speed)
      onChangeSpeed(speed)
    },
    [onChangeSpeed],
  )

  const handleSliderCommit = useCallback(() => {
    onChangeSpeed(displaySpeed)
  }, [displaySpeed, onChangeSpeed])

  return (
    <div className="w-full">
      <div className="flex items-center justify-center mb-3">
        <span className="text-sm font-semibold text-white">{displaySpeed.toFixed(2)}x</span>
      </div>
      <div className="px-2">
        <RangeSlider
          value={[displaySpeed]}
          onValueChange={([value]: number[]) => {
            setDisplaySpeed(value)
          }}
          onValueCommit={handleSliderCommit}
          min={min}
          max={max}
          step={step}
          className="w-full"
        />
      </div>

      <div className="flex items-center gap-2 mt-3 overflow-x-auto pb-1">
        {presetSpeeds.map((speed) => (
          <Button
            key={speed}
            onClick={() => handlePresetSpeed(speed)}
            variant={displaySpeed === speed ? 'default' : 'outline'}
            className="h-8 px-3! text-xs! font-medium whitespace-nowrap shrink-0"
          >
            {speed}x
          </Button>
        ))}
      </div>
    </div>
  )
}
